import { render, staticRenderFns } from "./BoxInspectionsTableDetails.vue?vue&type=template&id=b8c409d4&scoped=true"
import script from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
export * from "./BoxInspectionsTableDetails.vue?vue&type=script&lang=js"
import style0 from "./BoxInspectionsTableDetails.vue?vue&type=style&index=0&id=b8c409d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c409d4",
  null
  
)

export default component.exports